import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { LIST, listTypes, bindingTypes } from '@adalo/constants'

import { selectParent, getCurrentAppId } from 'ducks/editor/objects'
import { setLayersHover, setSelection } from 'ducks/editor/selection'
import { setActiveTab } from 'ducks/editor/tabs'
import { getAppLibraries } from 'ducks/apps'

import { getObjectName } from 'utils/naming'
import { ADD } from 'utils/tabs'
import { hasUnlicensedLibrary } from 'utils/libraries'

import { GroupedAccordion } from 'components/Shared/Accordion'
import Button from 'components/Shared/Button'
import Icon from 'components/Shared/Icon'

import NewActionRow from '../Actions/Row'
import { TYPE_NAMES } from '../RightPanel'
import SingleNumberControl from './SingleNumberControl'
import GenericInspectRow from './GenericRow'
import CommonListControl from './CommonListControl'

class ListControlChild$ extends Component {
  static displayName = 'ListControlChild'
  static propTypes = {
    object: PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
    setSelection: PropTypes.func.isRequired,
    setLayersHover: PropTypes.func.isRequired,
  }

  handleMouseEnter = () => {
    const { setLayersHover, object } = this.props
    setLayersHover(object.id)
  }

  handleMouseLeave = () => {
    const { setLayersHover } = this.props
    setLayersHover(null)
  }

  handleClick = () => {
    const { setSelection, object } = this.props
    setSelection(object.id, false)
  }

  render() {
    const { object, libraries } = this.props
    const unlicensed = hasUnlicensedLibrary(object, libraries)

    return (
      <div
        className={classnames('group-child-component', {
          'group-child-component-unlicensed': unlicensed,
        })}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div>
          <div className="group-child-component-type">
            {TYPE_NAMES[object.type]}
          </div>
          <div className="group-child-component-name">
            {getObjectName(object)}
          </div>
        </div>
        <i className="material-icons">arrow_forward</i>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const appId = getCurrentAppId(state)
  const libraries = getAppLibraries(state, appId)

  return { libraries }
}

const ListControlChild = connect(mapStateToProps, {
  setLayersHover,
  setSelection,
})(ListControlChild$)

class ListControl$ extends Component {
  static displayName = 'ListControl'

  static propTypes = {
    object: PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf([LIST]),
    }).isRequired,
    appId: PropTypes.string.isRequired,
    componentId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  handleAddComponent = () => {
    const { selectParent, setActiveTab, object } = this.props
    setActiveTab(ADD)
    selectParent(object.id)
  }

  handleListChange = ({ dataBinding }, opts = {}) => {
    const { onChange } = this.props

    onChange({
      dataBinding: {
        ...dataBinding,
        bindingType: bindingTypes.LIST,
      },
    })
  }

  handleColumnCountChange = ({ columnCount }) => {
    const { onChange } = this.props

    onChange({
      columnCount,
      listType:
        columnCount == null || columnCount <= 1
          ? listTypes.DEFAULT
          : listTypes.GRID,
    })
  }

  handleMarginChange = ({ rowMargin: value }) => {
    const { onChange } = this.props

    onChange({
      rowMargin: value != null ? value : 0,
    })
  }

  renderListAccordion = () => {
    const { appId, componentId, object } = this.props

    return (
      <>
        <CommonListControl
          isCustomList
          objectId={object.id}
          value={object.dataBinding}
          name="dataBinding"
          onChange={this.handleListChange}
          displayName="What is this a list of?"
        />
        <div className="border-control-split">
          <GenericInspectRow title="Columns">
            <SingleNumberControl
              gray
              name="columnCount"
              value={object.columnCount}
              minValue={1}
              maxValue={4}
              onChange={this.handleColumnCountChange}
            />
          </GenericInspectRow>
          <GenericInspectRow title="Items Spacing">
            <SingleNumberControl
              gray
              name="rowMargin"
              value={object.rowMargin}
              onChange={this.handleMarginChange}
            />
          </GenericInspectRow>
        </div>
        <NewActionRow
          displayName="Click Actions"
          appId={appId}
          componentId={componentId}
          object={object}
        />
      </>
    )
  }

  renderChildrenAccordion = () => {
    const { object } = this.props

    return (
      <>
        {object.children.map(child => (
          <ListControlChild key={child.id} object={child} />
        ))}
        <div className="list-control-add-wrapper">
          <Button
            square
            outlined
            block
            className="list-control-add"
            onClick={this.handleAddComponent}
          >
            <Icon type="plus-small" />
            <span> Add Component</span>
          </Button>
        </div>
      </>
    )
  }

  render() {
    const { object } = this.props

    return (
      <>
        <GroupedAccordion
          defaultExpanded
          group="form-inspect-field"
          className="library-inspect-accordion"
          title="List"
          object={object}
          renderChildren={this.renderListAccordion}
        />
        <GroupedAccordion
          group="form-inspect-field"
          className="library-inspect-accordion"
          title="Components"
          object={object}
          renderChildren={this.renderChildrenAccordion}
        />
      </>
    )
  }
}

export default connect(null, { setActiveTab, selectParent })(ListControl$)
